import React, { useEffect, useState } from "react";
import { Routes, Route, Outlet, useNavigate } from "react-router-dom";
import api from "../services/api";
import { Row, Col, Button, Alert } from "reactstrap";
import EmployeeNav from "./EmployeeNav";
import EmpRequest from "./EmpRequest"; // Import EmpRequest component
import PaySummary from "./PaySummary";
import EmpDeductions from "./EmpDeductions";
import EmployeeBenefitSummary from "./EmployeeBenefitSummary";

const EmployeeDashboard = () => {
  const navigate = useNavigate();
  const [employee, setEmployee] = useState({ id: "", first_name: "", last_name: "", business_id: "" });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const employeeResponse = await api.post("/employee/profile");
        if (!employeeResponse.data || !employeeResponse.data.id) {
          throw new Error("Unauthorized access");
        }
        setEmployee(employeeResponse.data);

        
      } catch (error) {
        setError(error.response ? error.response.data : "Server error");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeData();
  }, [navigate]);



  const handleLogout = async () => {
    try {
        // Invalidate the refresh token and clear the cookie on the server
        await api.post("/logout");

        // Remove any stored access tokens (if you're storing it anywhere)
        localStorage.removeItem("accessToken");
        sessionStorage.removeItem("accessToken");

        // Remove Authorization header from future requests
        delete api.defaults.headers.common["Authorization"];

        // Redirect to public page
        navigate("/home");

        // Force full reload to clear any React state and cached user data
        window.location.reload();
    } catch (error) {
        console.error("Logout failed:", error);
    }
};



  if (loading) return <p className="text-center mt-5">Loading...</p>;

  return (


    
    



    <div>
      <header>
            <div>
            <h3>
            
            
            Payweek
            
            
            </h3>
            </div>
                <div>
                <button className="logout-button" onClick={handleLogout}>
                    Logout
                </button>
                </div>
                

                
            </header>
      <Row>
        <Col lg="3">
          <EmployeeNav businessId={employee.business_id} />
        </Col>

        <Col lg="12">
          <Routes>
            <Route path="/" element={<Outlet />}>
              {/* Default dashboard content */}
              <Route index element={
                <div>
                  <div>
                    <h2>Employee Dashboard</h2>

                    {error ? (
                      <Alert color="danger">
                        {error} <br />
                        <Button color="link" onClick={() => navigate("/emp-login")}>
                          Click here to log in again.
                        </Button>
                      </Alert>
                    ) : (
                      <>
                        <p className="text-muted">Welcome, {employee.first_name} {employee.last_name}!</p>
                       

                        
                        
                      </>
                    )}

                    
                  </div>
                </div>
              } />

              {/* Nested EmpRequest Route */}
              
              <Route path='emp-request' element={<EmpRequest businessId={employee.business_id} />} />

              <Route path='emp-deductions' element={<EmpDeductions businessId={employee.business_id} />} />

              <Route path="emp-benefits-summary" element={<EmployeeBenefitSummary />} />



              <Route path='pay-summary' element={<PaySummary />} />

            </Route>
            

          </Routes>
        </Col>
      </Row>
    </div>
  );
};

export default EmployeeDashboard;




// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";
// import { Container, Row, Col, Card, CardBody, Button, Alert, Table } from "reactstrap";
// import EmployeeNav from "./EmployeeNav";

// const EmployeeDashboard = () => {
//   const navigate = useNavigate();
//   const [employee, setEmployee] = useState({ id: "", first_name: "", last_name: "" });
//   const [payrollData, setPayrollData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchEmployeeData = async () => {
//       try {
//         // Fetch employee profile
//         const employeeResponse = await api.post("/employee/profile");

//         if (!employeeResponse.data || !employeeResponse.data.id) {
//           throw new Error("Unauthorized access");
//         }

//         setEmployee(employeeResponse.data);

//         // Fetch payroll data for employee
//         const payrollResponse = await api.get("/employee/payroll");

//         if (payrollResponse.status === 200) {
//           setPayrollData(payrollResponse.data);
//         } else {
//           throw new Error("No payroll records found.");
//         }
//       } catch (error) {
//         setError(error.response ? error.response.data : "Server error");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEmployeeData();
//   }, [navigate]);

//   if (loading) {
//     return <p className="text-center mt-5">Loading...</p>;
//   }

//   return (
//     <>
//     <EmployeeNav businessId={employee.business_id}/>
//     <Container className="mt-5">
//       <Row className="justify-content-center">
//         <Col lg="8">
//           <Card className="shadow-lg">
//             <CardBody className="text-center">
//               <h2 className="mb-3">Employee Dashboard</h2>

//               {error ? (
//                 <Alert color="danger">
//                   {error} <br />
//                   <Button color="link" onClick={() => navigate("/emp-login")}>
//                     Click here to log in again.
//                   </Button>
//                 </Alert>
//               ) : (
//                 <>
//                   <p className="text-muted">Welcome, {employee.first_name} {employee.last_name}!</p>
//                   <h4 className="font-weight-bold">Employee ID: {employee.id}</h4>
//                   <h4 className="font-weight-bold">Business ID: {employee.business_id}</h4>

//                   <h5 className="mt-4">Payroll Records</h5>
//                   {payrollData.length > 0 ? (
//                     <Table striped bordered responsive className="mt-3">
//                       <thead>
//                         <tr>
                          
//                           <th>Pay Period</th>
//                           <th>Gross Pay</th>
//                           <th>Net Pay</th>
                          
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {payrollData.map((record) => (
//                           <tr key={record.id}>
                            
//                             <td>{new Date(record.pay_date).toLocaleDateString()}</td>
//                             <td>${record.grosspay}</td>
//                             <td>${record.net_pay}</td>
                            
//                           </tr>
//                         ))}
//                       </tbody>
//                     </Table>
//                   ) : (
//                     <p className="text-muted mt-3">No payroll records available.</p>
//                   )}
//                 </>
//               )}

//               <Button color="primary" className="mt-3" onClick={() => navigate("/emp-login")}>
//                 Logout
//               </Button>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//     </>
//   );
// };

// export default EmployeeDashboard;




// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";
// import { Container, Row, Col, Card, CardBody, Button, Alert } from "reactstrap";

// const EmployeeDashboard = () => {
//   const navigate = useNavigate();
//   const [employee, setEmployee] = useState({ id: "", first_name: "", last_name: "" });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchEmployeeData = async () => {
//       try {
//         // Make sure token is automatically attached from headers
//         const response = await api.post("/employee/profile"); // ✅ Headers are handled by axios globally

//         if (!response.data || !response.data.id) {
//           throw new Error("Unauthorized access");
//         }

//         setEmployee(response.data);
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEmployeeData();
//   }, [navigate]);

//   if (loading) {
//     return <p className="text-center mt-5">Loading...</p>;
//   }

//   return (
//     <Container className="mt-5">
//       <Row className="justify-content-center">
//         <Col lg="6">
//           <Card className="shadow-lg">
//             <CardBody className="text-center">
//               <h2 className="mb-3">Employee Dashboard</h2>

//               {error ? (
//                 <Alert color="danger">
//                   {error} <br />
//                   <Button color="link" onClick={() => navigate("/emp-login")}>
//                     Click here to log in again.
//                   </Button>
//                 </Alert>
//               ) : (
//                 <>
//                   <p className="text-muted">Welcome, {employee.first_name} {employee.last_name}!</p>
//                   <h4 className="font-weight-bold">Employee ID: {employee.id}</h4>
//                 </>
//               )}

//               <Button color="primary" className="mt-3" onClick={() => navigate("/emp-login")}>
//                 Logout
//               </Button>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default EmployeeDashboard;

